import { FC, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { HelpModal } from "../../common/compoents/HelpModal";
import { IoMdPlay } from "react-icons/io";
import { ToolsHeader } from "../../components/ToolsHeader";
import { isInIframe } from "../../../utils/is-in-iframe";

type Props = {};

export const Header: FC<Props> = () => {
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const closeVideoModal = () => {
    setShowVideoModal(false);
  };
  const openVideoModal = () => {
    setShowVideoModal(true);
  };
  const helpSteps = [
    "Paste the content you want to analyze into the designated text area.",
    "Click 'Analyze Content' to generate an AI-generated content estimate and SEO grade.",
    "The tool will display the AI percentage and SEO grading based on the analysis.",
  ];

  return (
    <>
      {" "}
      <Row style={{ padding: "0px" }}>
        <Col lg={12}>
          <HelpModal
            helpSteps={helpSteps}
            show={showVideoModal}
            close={closeVideoModal}
            videoUrl="https://www.youtube.com/embed/hNce9hFpBOY"
          />
          {!isInIframe && (
            <ToolsHeader
              title="SEO Content Grader/Optimizations"
              description="Analyze content for AI generation and assess its SEO
                optimization quality effectively."
            />
          )}
          {/* <div
            style={{
              display: "flex",

              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <div>
              <h1
                style={{ fontSize: "20px" }}
                className="
           mb-3"
              >
                SEO Content Grader/Optimizations
              </h1>
              <p className="mb-4">
                Analyze your content to determine if it was generated by AI and
                assess its SEO optimization quality.
              </p>
            </div>
            <div className="d-flex justify-content-center mb-4">
              <Button
                variant="outline-primary d-flex justify-content-center align-items-center"
                size="sm"
                onClick={openVideoModal}
              >
                See how to use <IoMdPlay className="ms-2" />
              </Button>
            </div>
          </div> */}
        </Col>
      </Row>
    </>
  );
};
